import React, { useEffect, useState, memo, useCallback } from 'react';
import AnswerTypeText from '../../../pages/spq/components/AnswerTypeText';
import AnswerTypeRadio from '../../../pages/spq/components/AnswerTypeRadio';
import AnswerTypeCheck from '../../../pages/spq/components/AnswerTypeCheck';
import AnswerTypeImage from '../../../pages/spq/components/AnswerTypeImage';
import AnswerTypeOther from '../../../pages/spq/components/AnswerTypeOther';
import { useDispatch, useSelector } from 'react-redux';
// import '../../../components/centerModal/css/centerModal.css';

import { HiArrowNarrowLeft, MdOutlineArrowRightAlt } from '../../../components/icons';
import ProgressBar from 'react-bootstrap/ProgressBar';
// import '../../CustomLibraries/videoPlayer/css/videoSpqQuestion.css';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';

// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);
import {
  getPendingDetails,
  getSpqDetails,
  postQuizAnswer,
  postSaveSurvey
} from '../../../Store/actions/spq.action';
import { useLocation } from 'react-router-dom';
import Timer from '../../../pages/spq/components/Timer';
import QuestionLoader from '../../../skeleton/spq/QuestionLoader';
import { generateDataLayerGtm } from '../../../helper/generateDataLayerGtm';
import { pageTitles } from '../../../common/pageTitles';
import useRedirect from '../../../components/customHooks/useRedirect';
import { EVENT, SELECT_QUESTION_OPTION } from '../../../TrackerFolder/constants/ActionType';
import { onAnswerSelect, trackEvent } from '../../../TrackerFolder/actions/UserActions';
import {
  handleCompressedUpload,
  generateTitle,
  isApp,
  log,
  openNewTab,
  reactHtmlParser
} from '../../../common/common';
// import ReactHtmlParser from 'react-html-parser';
import AnswerTypeUpload from '../../../pages/spq/components/AnswerTypeUpload';
import { CapacitorFirebaseUpload, firebaseUpload } from '../../../common/firebase';
import { getFcmToken } from '../../../Store/actions';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import { saveFileObject } from '../../../Store/actions/app.action';
import BackdropComponent from '../../BackdropComponent';
import AnswerTypeRank from '../../../pages/spq/components/AnswerTypeRank';
import { verifyTheOtp } from '../../../Store/actions/login.action';
import LazyImage from '../../CustomLibraries/LazyImage';
import PollCardV1d from '../../cards/poll/pollCardV1/PollCardV1d';
import { Capacitor } from '@capacitor/core';

var qArray = [];
var initialArray = [];
const pageTitle = pageTitles.spq.question;
var tempTime;

const InModalSpq = ({ id = '', skipBtn = false, height = 0, handleClose, data }) => {
  // console.log('data ===>', data);
  // const {spq_id,isCompleted,isSkipButton}=data;
  const { redirectTo } = useRedirect();
  const fileObj = useSelector((state) => state.app.file);
  const searchElement = (idKey, myArray) => {
    return myArray.find((element) => element.id == idKey);
  };
  const [disabled, setDisabled] = useState(false);
  const [title, setTitle] = useState('');
  const [firebaseToken, setFirebaseToken] = useState('');
  const [questionNo, setQuestionNo] = useState(0);
  const [category, setCategory] = useState('');
  const [render, setRender] = useState(false);
  const [time, setTime] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isd, setIsd] = useState('+91');
  const [otp, setOtp] = useState('');
  const [err_msg, set_err_msg] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);
  const [loader, setLoader] = useState(true);
  const [consent, setConsent] = useState(false);
  const [sponsorLogo, setSponsorLogo] = useState([]);
  const [backdrop, setBackdrop] = useState(false);
  const [approval, setApproval] = useState(0);
  const [progress, setProgress] = useState(0);
  const [spqId, setSpqId] = useState(id);
  const [isSkipButton, setIsSkipButton] = useState(skipBtn);
  // const { spqId, pending } = queryString.parse(search);

  const pending = false;
  const dispatch = useDispatch();
  const { trackActivityEvent } = useTracker();
  const handleShow = () => setShow(true);
  // const handleClose = () => setShow(false);
  const refresh = () => {
    setRender(!render);
  };

  useEffect(() => {
    if (data?.survey_id) {
      console.log('data?.survey_id', data);
      dispatch(getFcmToken(setFirebaseToken));
      var parsedData = JSON.parse(data?.data_json);

      // log('PARSED JSON', parsedData);
      if (parsedData) {
        qArray = Object.keys(parsedData.surveys).map((k) => {
          return parsedData.surveys[k];
        });
        initialArray = JSON.parse(
          JSON.stringify(
            Object.keys(parsedData.surveys).map((k) => {
              return parsedData.surveys[k];
            })
          )
        );
      }
      // qArray = Object.keys(parsedData.surveys).map((k) => {
      //   return parsedData.surveys[k];
      // });
      // initialArray = JSON.parse(
      //   JSON.stringify(
      //     Object.keys(parsedData.surveys).map((k) => {
      //       return parsedData.surveys[k];
      //     })
      //   )
      // );
      // log('Question array', qArray);
      log('Question array', qArray);

      setTitle(data?.survey_title);
      setCategory(data?.category);
      let sponsor_logo = data?.sponsor_logo ? data?.sponsor_logo.split(',') : [];
      setSponsorLogo(sponsor_logo);
      setApproval(data?.points_on_approval);
      setLoader(false);
      if (data.verified == 1) {
        handleShow();
        tempTime = data?.survey_time;
      } else {
        setTime(data?.survey_time);
      }
    } else {
      redirectTo('Unavailable');
    }
  }, [data]);

  const submitQuiz = () => {
    setDisabled(true);
    console.log('post test', id, data?.survey_id, approval);
    // console.log('post test 2', qArray);
    dispatch(
      postQuizAnswer(data?.survey_id, JSON.stringify(qArray), approval, (res) => {
        setDisabled(false);
        if (res != 'error') {
          log('POST RESPONSE', res.data);
          handleClose();
          toast.success('Thank you for your participation');
        } else {
          handleClose();
          toast.success('Something went wrong.');
        }
      })
    );
  };
  const handleRankChange = (value) => {
    trackActivityEvent(SELECT_QUESTION_OPTION, onAnswerSelect(value));
    qArray[questionNo].options = value;
  };
  const handleRadioChange = (index, value) => {
    trackActivityEvent(SELECT_QUESTION_OPTION, onAnswerSelect(value));
    qArray[questionNo].selectedIndex = index;
    if (qArray[questionNo].type == 'consent') {
      if (value?.toLowerCase() == 'yes') setConsent(true);
      else setConsent(false);
    }
    refresh();
    log('modified', qArray);
  };
  const handleCheckChange = (id, index) => {
    trackActivityEvent(SELECT_QUESTION_OPTION, onAnswerSelect(id));
    searchElement(id, qArray[questionNo].options).isChecked = !searchElement(
      id,
      qArray[questionNo].options
    ).isChecked;
    refresh();
    log('modified', qArray);
  };
  const handleTextChange = (text) => {
    qArray[questionNo].textAnswer = text;
    refresh();
    log('modified', qArray);
  };
  const nextPrevHandler = () => {
    if (questionNo < qArray.length - 1) {
      setQuestionNo(questionNo + 1);
    } else if (questionNo == qArray.length - 1) {
      submitQuiz();
      // onQuizComplete();
    }
  };
  const nextClick = () => {
    trackActivityEvent(EVENT, trackEvent('CLICK_NEXT'));
    if (
      qArray[questionNo].type == 'single' ||
      qArray[questionNo].type == 'other' ||
      qArray[questionNo].type == 'boolean' ||
      qArray[questionNo].type == 'consent'
    ) {
      if ('selectedIndex' in qArray[questionNo] && qArray[questionNo].selectedIndex !== '') {
        nextPrevHandler();
      } else {
        toast.error('Please Select Any of the options');
      }
    } else if (qArray[questionNo].type == 'multiple' || qArray[questionNo].type == 'image') {
      if (qArray[questionNo].options.map((_el) => _el.isChecked).includes(true)) {
        nextPrevHandler();
      } else {
        toast.error('Please Select Any of the options');
      }
    } else if (qArray[questionNo].type == 'text') {
      if (qArray[questionNo].textAnswer) {
        nextPrevHandler();
      } else {
        toast.error('Please Give a answer');
      }
    } else if (qArray[questionNo].type == 'fileupload') {
      if (qArray[questionNo]?.attachedFile) {
        nextPrevHandler();
      } else {
        toast.error('Please Give a answer');
      }
    } else if (qArray[questionNo].type == 'ranking') {
      console.log(
        'rankTypeChecker',
        'new',
        `${qArray[questionNo]?.options?.map((i) => i.id)}`,
        'old',
        `${initialArray[questionNo]?.options?.map((i) => i.id)}`
      );
      if (
        `${qArray[questionNo]?.options?.map((i) => i.id)}` !=
        `${initialArray[questionNo]?.options?.map((i) => i.id)}`
      ) {
        nextPrevHandler();
      } else {
        toast.error('Please Give a answer');
      }
    }
  };
  // const saveToPending = () => {
  //   trackActivityEvent(EVENT, trackEvent('CLICK_COMPLETE_LATER'));
  //   dispatch(
  //     postSaveSurvey(id, questionNo, JSON.stringify(qArray), (res) => {
  //       if (res != 'error') {
  //         log('incomplete response', res.data);
  //         redirectTo('SPQperformed', '', '', 'status=pending');
  //       }
  //     })
  //   );
  // };
  // const GetOtpFunc = (e) => {
  //   e.preventDefault();
  //   if (mobileNo == '') {
  //     set_err_msg('Please Enter Your Mobile No');
  //   } else {
  //     let regexMob = /^\d{10}$/;
  //     if (!mobileNo.match(regexMob)) {
  //       set_err_msg('Please Enter Mobile No in Correct Format');
  //     } else {
  //       let formData = new FormData();
  //       formData.append('isdCode', isd);
  //       formData.append('phone_no', mobileNo);
  //       dispatch(
  //         otpVerification(formData, (res) => {
  //           if (res != 'error') {
  //             if (res.status_code == 203) {
  //               set_err_msg(res.message);
  //             } else if (res.status_code == 200) {
  //               log('otp API response', res);
  //               setShowOtpField(true);
  //             } else {
  //             }
  //           } else {
  //             set_err_msg('Something Went Wrong');
  //           }
  //         })
  //       );
  //     }
  //   }
  // };
  // const verifyOtp = (e) => {
  //   e.preventDefault();
  //   if (otp == '') {
  //     set_err_msg('Please Enter the Otp');
  //   } else {
  //     let formData = new FormData();
  //     formData.append('isdCode', isd);
  //     formData.append('phone_no', mobileNo);
  //     formData.append('otp', otp);
  //     dispatch(
  //       verifyTheOtp(formData, (res) => {
  //         log('verified response', res);
  //         if (res != 'error') {
  //           if (res.status_code == 203) {
  //             set_err_msg('Please Check Your Otp');
  //           } else if (res.status_code == 200) {
  //             if (res.data.status == 3) {
  //               handleClose();
  //               setTime(tempTime);
  //             } else {
  //               redirectTo(`SPQdetails`, id, title);
  //             }
  //           } else {
  //             redirectTo(`SPQdetails`, id, title);
  //           }
  //         } else {
  //           set_err_msg('Something Went Wrong');
  //         }
  //       })
  //     );
  //   }
  // };
  const startFirebaseUpload = (file) => {
    firebaseUpload(
      file,
      firebaseToken,
      ['jpg', 'jpeg', 'png', 'pdf'],
      (_p) => setProgress(_p),
      (url) => {
        qArray[questionNo].attachedFile = {
          type: file.type,
          url
        };
        setBackdrop(false);
        log('modified', qArray);
        setProgress(0);
      },
      () => {
        setBackdrop(false);
        setProgress(0);
      }
    );
  };

  const handleAppFileUpload = (compressedFile) => {
    if (Capacitor.getPlatform() == 'ios' || 'android') {
      CapacitorFirebaseUpload(
        compressedFile,
        firebaseToken,
        ['jpg', 'jpeg', 'png'],
        (_p) => setProgress(_p),
        (url) => {
          qArray[questionNo].attachedFile = {
            type: file.type,
            url
          };
          setBackdrop(false);
          log('modified', qArray);
          setProgress(0);
        },
        () => {
          setBackdrop(false);
          setProgress(0);
        }
      );
    }
  }

  const fileUpload = (e) => {
    if (e) {
      console.log('EVENT FILE', e.type.includes('image'));
      if (e.type.includes('image')) {
        handleCompressedUpload(e, (compressedFile) => {
          setBackdrop(true);
          toast.info('Please Wait...');
          startFirebaseUpload(compressedFile);
        });
      } else {
        setBackdrop(true);
        toast.info('Please Wait...');
        startFirebaseUpload(e);
      }
    }
  };
  const cancelClick = () => {
    qArray[questionNo].attachedFile = null;
    refresh();
  };
  function get_url_extension(url) {
    console.log('FILE TYPE===>>>>', url.split(/[#?]/)[0].split('.').pop().trim());
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }
  useEffect(() => {
    if (isApp() && fileObj) {
      qArray[questionNo].attachedFile = {
        type: get_url_extension(fileObj) == 'pdf' ? 'application/pdf' : get_url_extension(fileObj),
        url: fileObj
      };
      refresh();
    }
  }, [fileObj]);
  console.log('inpopup', data.survey_title);
  console.log('last submitted quary', qArray);
  return (
    <>
      <div className="w-100 spqQuestion">
        <div className="d-flex flex-wrap justify-content-center">
          {qArray.length > 0 && !loader ? (
            data?.category == 'poll' ? (
              <PollCardV1d
                data={data}
                noShare
                onCompletePoll={() => setTimeout(() => handleClose(), 1000)}
              />
            ) : (
              <div className="col-12 spqQuestionBox text-start rounded">
                <h1 className="fs-2 text-black fw-semibold spqQuestionTopic mb-4">
                  {reactHtmlParser(title)}
                  {time && category == 'quiz' && (
                    <span className=" bg-secondary text-white fs-4 fw-normal spqQuestionTime rounded-3">
                      <Timer minutes={time} onEnded={submitQuiz} onDuration={(e) => { }} />
                    </span>
                  )}
                </h1>
                <div className="w-100">
                  {qArray[questionNo]?.questionImageURL && (
                    <div className="row justify-content-center">
                      <div
                        className="col-md-6 col-12 mb-3 spqQuestionImagePreview cursorPointer"
                        onClick={() =>
                          openNewTab(qArray[questionNo]?.questionImageURL, () => {
                            window.location.href = qArray[questionNo]?.questionImageURL;
                          })
                        }
                      >
                        <img
                          src={qArray[questionNo]?.questionImageURL}
                          alt="Question Image"
                          className="object-fit-cover w-100 h-100 float-start rounded-3"
                        />
                      </div>
                    </div>
                  )}
                  <h2 className="fs-3 fw-normal spqQuestionTtl text-black mt-4 mb-3">
                    {qArray[questionNo].question}
                  </h2>
                  <div className="w-100  mt-4">
                    <div className="spqAnswerArea">
                      {(qArray[questionNo].type == 'single' ||
                        qArray[questionNo].type == 'boolean' ||
                        qArray[questionNo].type == 'consent') && (
                          <AnswerTypeRadio
                            data={qArray[questionNo]}
                            qNo={questionNo}
                            onChangeRadio={handleRadioChange}
                            type={qArray[questionNo].type}
                          />
                        )}
                      {qArray[questionNo].type == 'multiple' && (
                        <AnswerTypeCheck
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          onChangeCheck={handleCheckChange}
                        />
                      )}
                      {qArray[questionNo].type == 'text' && (
                        <AnswerTypeText
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          onTextCheck={handleTextChange}
                          isReview={false}
                        />
                      )}
                      {qArray[questionNo].type == 'image' && (
                        <AnswerTypeImage
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          onChangeCheck={handleCheckChange}
                        />
                      )}
                      {qArray[questionNo].type == 'other' && (
                        <AnswerTypeOther
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          onChangeRadio={handleRadioChange}
                        />
                      )}
                      {qArray[questionNo].type == 'fileupload' && (
                        <AnswerTypeUpload
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          onTextCheck={handleTextChange}
                          fileUpload={fileUpload}
                          cancelClick={cancelClick}
                            backdrop={backdrop}
                            appFileUpload={handleAppFileUpload}
                        />
                      )}
                      {qArray[questionNo].type == 'ranking' && (
                        <AnswerTypeRank
                          data={qArray[questionNo]}
                          qNo={questionNo}
                          handleRankChange={handleRankChange}
                        />
                      )}

                      <div className="w-100">
                        <div className="row justify-content-center mt-4">
                          <div className="col-lg-6 col-md-8 col-12 text-center spqAnswerSubmit mt-4">
                            <ProgressBar
                              now={(questionNo / qArray.length) * 100}
                              label={`${Math.floor((questionNo / qArray.length) * 100)}%`}
                              className="spqAnswerProgress"
                            />
                          </div>
                          <div className="col-12 text-center spqAnswerSubmit mt-4">
                            <div className="d-flex justify-content-center flex-wrap mt-5">
                              {questionNo > 0 && (
                                <a
                                  href="javascript:void(0)"
                                  className="fs-16 text-white bg-black cmnBtn rounded-pill"
                                  onClick={() => {
                                    if (questionNo > 0) {
                                      setQuestionNo(questionNo - 1);
                                    }
                                  }}
                                >
                                  <HiArrowNarrowLeft customClass="fs-2 me-2" /> Prev
                                </a>
                              )}
                              <a
                                href="javascript:void(0)"
                                className="fs-16 text-white bg-primary cmnBtn rounded-pill"
                                onClick={nextClick}
                              >
                                {questionNo == qArray.length - 1 ? 'Submit' : 'Next'}
                                <MdOutlineArrowRightAlt customClass="fs-2 ms-2" />
                              </a>
                            </div>
                            {consent && (
                              <>
                                <h2 className="fs-4 text-black fw-semibold mt-3">Please Note</h2>
                                <p>{qArray[questionNo].disclaimer}</p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      {sponsorLogo?.length > 0 && (
                        <div className="w-100">
                          <div className="row justify-content-center mt-4">
                            <span className="fw-semibold text-center mb-3">Powered By</span>
                            {sponsorLogo?.length == 1 && (
                              <div className="spqQuestionsponser">
                                <div className="spqQuestionsponserIn">
                                  <LazyImage src={sponsorLogo[0]} alt="sponsor" logo />
                                </div>
                              </div>
                            )}
                            {sponsorLogo?.length > 1 && (
                              <Swiper
                                className="spqQuestionsponser"
                                navigation={false}
                                spaceBetween={0}
                                slidesPerView={1}
                                loop={true}
                                autoplay={{
                                  delay: 2500
                                }}
                                effect={'fade'}
                              >
                                {sponsorLogo?.map((_sp, index) => (
                                  <SwiperSlide className="spqQuestionsponserIn" key={index + 1}>
                                    <LazyImage src={_sp} logo />
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : loader ? (
            <QuestionLoader />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default memo(InModalSpq);
